document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mainNav = document.querySelector('[data-main-nav]');
  if (menuToggle && mainNav) {
    menuToggle.addEventListener('click', function () {
      mainNav.classList.toggle('is-open');
    });
  }

  // Search panel toggle
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.toggle('is-open');
      var input = searchPanel.querySelector('input');
      if (searchPanel.classList.contains('is-open') && input) input.focus();
    });
  }

  // Scroll-reveal animation
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Sticky header shadow on scroll
  var header = document.querySelector('[data-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    });
  }

  // Product gallery thumbnails
  var mainImage = document.getElementById('ProductMainImage');
  var thumbs = document.querySelectorAll('[data-thumb]');
  if (mainImage && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.getAttribute('data-full');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  // Quantity stepper
  document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('.qty-input');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
    });
  });

  // Product option pills -> sync hidden variant select
  var variantSelect = document.querySelector('[data-variant-select]');
  document.querySelectorAll('.product-option-radio').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (!variantSelect) return;
      // naive sync: reselect matching option text across all option groups
      var selectedValues = [];
      document.querySelectorAll('.product-option').forEach(function (group) {
        var checked = group.querySelector('.product-option-radio:checked');
        if (checked) selectedValues.push(checked.value.trim());
      });
      var options = variantSelect.querySelectorAll('option');
      options.forEach(function (opt) {
        var title = opt.textContent.replace('— Sold Out', '').trim();
        var parts = title.split(' / ').map(function (s) { return s.trim(); });
        var matches = selectedValues.every(function (val) { return parts.indexOf(val) !== -1; });
        if (matches) {
          variantSelect.value = opt.value;
          variantSelect.dispatchEvent(new Event('change'));
        }
      });
    });
  });

  // Accordion (product details + FAQ)
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.accordion-item');
      var wasOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.accordion-item').forEach(function (i) {
        i.classList.remove('is-open');
      });
      if (!wasOpen) item.classList.add('is-open');
    });
  });

  // Collection filter drawer (mobile)
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.querySelector('[data-filter-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      filterPanel.classList.toggle('is-open');
    });
  }
});
